import axios from "axios";

export const baseHelpdeskApi = axios.create({
  baseURL: process.env.VUE_APP_HELPDESK_API,
  headers: {
    "Content-type": "application/json",
  },
});
